module.exports = __webpack_public_path__ + "img/s6Icon3.eb024947.png";